<app-navbar-style-one></app-navbar-style-one>

<div class="home-slider owl-carousel owl-theme">
    <div class="slider-item" 
        style="background-image: url('../../../assets/img/home2/order-online.jpg');">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                    <div class="slider-content">
                        <h1>Offers</h1>
                        <p>"Craving wings or sandwiches? Order online and we’ll have it hot and ready!"</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- that comes from home sub category icons that exists in the grid in home page -->
<section class="realMenuItems mt-4 mb-3">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 text-center">
                <span class="currentRoute">{{'offers' | titlecase}}</span>
            </div>
            <div class="col-12 mt-5 items">
                <div class="row">
                    <div class="col-12 text-center">
                        <div class="spinner-grow" role="status" *ngIf="isLoading">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                    <div class="col-12" *ngIf="!isLoading">
                        <div class="row">
                            <div class="col-lg-6 mt-3" *ngFor="let item of subCategoryProducts">
                                <div class="menu-container">
                                    <a (click)="toggleFav(item.id)" class="">
                                        <i class="bx bx-heart heart" [class.bxs-heart]="item.isFavorite" [class.bxs-heart.text-danger]="isFavorite(item.id)" [class.text-danger]="item.isFavorite"></i>
                                    </a>
                                    <img src="{{item.avatar}}" class="itemImage" width="200" height="200" alt="{{item.name}}">
                                    <div class="item-data">
                                        <h2>{{item.name}}</h2>
                                        <p class="itemDesc ellipsis">{{item.components}}</p>
                                        <span class="price" *ngIf="item.offer && item.show_price == 1; else noOffer">
                                            <!-- When offer exists -->
                                            <span class="original-price" *ngIf="item.offer.type === 'percentage' || item.offer.type === 'discount'">
                                                {{item.types[0].price}} $
                                            </span>
                                            <span class="price text-danger">
                                                {{ calculateDiscountedPrice(item) }} $
                                            </span>
                                            <span class="offer-badge">
                                                {{ getOfferText(item.offer) }}
                                            </span>
                                        </span>
                                        <ng-template #noOffer>
                                            <span *ngIf="item.show_price == 1" class="price">{{item.types[0].price}} $</span>
                                        </ng-template>
                                        
                                        <span class="clear-both"></span>
                                    </div>
                                    <div class="row" style="align-items: end;">
                                        <div class="col-12">
                                            <button class="btn btn-primary" 
                                                data-bs-toggle="modal" 
                                                data-bs-target="#itemModalDetails" 
                                                (click)="selectProduct(item.id)">
                                                Order Now
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12 mt-3" *ngIf="subCategoryProducts.length == 0">
                            <div class="alert alert-danger">
                                <strong>Oops!</strong> No Products Found
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Pagination Controls -->
<div class="col-12 mt-4" *ngIf="subCategoryProducts.length > 0 && totalPages > 1">
  <nav aria-label="Page navigation">
    <ul class="pagination justify-content-center">
      <li class="page-item" [class.disabled]="currentPage === 1">
        <a class="page-link" (click)="goToPage(currentPage - 1)" aria-label="Previous">
          <span aria-hidden="true">&laquo;</span>
        </a>
      </li>
      
      <li class="page-item" *ngFor="let page of getPagesArray()" 
          [class.active]="page === currentPage">
        <a class="page-link" (click)="goToPage(page)">{{page}}</a>
      </li>
      
      <li class="page-item" [class.disabled]="currentPage === totalPages">
        <a class="page-link" (click)="goToPage(currentPage + 1)" aria-label="Next">
          <span aria-hidden="true">&raquo;</span>
        </a>
      </li>
    </ul>
  </nav>
  
  <div class="text-center text-muted mt-2">
    Showing page {{currentPage}} of {{totalPages}} ({{subCategoryProducts.length}} of {{totalItems}} items)
  </div>
</div>

<!-- Modal -->
<div class="modal fade" id="itemModalDetails" data-bs-keyboard="false" 
    tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="itemModalDetailsLabel">{{selectedProduct.name}}</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-lg-6">
                            <h5 class="fw-bold mb-3 descriptionTitle">Description</h5>
                            <p class="mb-4 descriptionParagraph">{{selectedProduct.components}}</p>
                            
                            <!-- Dynamic Size Selection -->
                            <div class="list-group mb-4 sizeDiv" *ngIf="selectedProduct.types?.length">
                                <h5 class="fw-bold mb-1">Size <label *ngIf="selectedProduct.offer" style="font-size: 15px;" class="offer-badge">{{ getOfferText(selectedProduct.offer) }}</label></h5>
                                <label class="list-group-item d-flex justify-content-between align-items-center"
                                    *ngFor="let type of selectedProduct.types">
                                    <span>
                                        <span>{{type.name}}</span>
                                        <span *ngIf="selectedProduct.offer">
                                            <span class="text-muted text-decoration-line-through me-2 ms-2">
                                                {{type.price | currency}}
                                            </span>
                                            <span class="text-danger fw-bold">
                                                {{calculateDiscountedPrice2(selectedProduct, type.price) | currency}}
                                            </span>
                                        </span>
                                        <span class="text-danger ms-2" *ngIf="!selectedProduct.offer">{{type.price | currency}}</span>
                                    </span>
                                    <input type="radio" 
                                        name="size" 
                                        class="form-check-input" 
                                        [value]="type.id"
                                        [(ngModel)]="selectedSize">
                                </label>
                            </div>
                            
                            <!-- Free Sides Section -->
                            <div class="list-group extraDiv mb-4" *ngIf="selectedProduct.free_side > 0 && selectedProduct.sideproducts?.length > 0">
                                <h5 class="fw-bold mb-1">
                                    {{selectedProduct.sides_name}} 
                                    <small class="text-muted">(Choose {{selectedProduct.free_side}})</small>
                                    <span *ngIf="selectedFreeSides.length >= selectedProduct.free_side" class="text-danger ms-2">
                                        (Maximum {{selectedProduct.free_side}} free sides reached)
                                    </span>
                                </h5>
                                <label class="list-group-item d-flex justify-content-between align-items-center"
                                    *ngFor="let side of selectedProduct.sideproducts">
                                    <span>{{side.name}}</span>
                                    <input type="checkbox" 
                                        class="form-check-input" 
                                        [checked]="isSideSelected(side.id)"
                                        (change)="toggleFreeSide(side)"
                                        [disabled]="!isSideSelected(side.id) && selectedFreeSides.length >= selectedProduct.free_side">
                                </label>
                            </div>
                            
                            <!-- Extras with Quantity Control -->
                            <div class="list-group extraDiv mb-4" *ngIf="selectedProduct.extraproducts?.length">
                                <h5 class="fw-bold mb-1">Extras</h5>
                                <div class="list-group-item" *ngFor="let extra of selectedProduct.extraproducts">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <span>{{extra.name}} - {{extra.price | currency}}</span>
                                        <div class="d-flex align-items-center">
                                            <button class="btn quantity-btn" 
                                                style="border: 0;"
                                                (click)="decreaseExtraQuantity(extra)"
                                                [disabled]="getExtraQuantity(extra.id) === 0">
                                                <i class="bx bx-minus"></i>
                                            </button>
                                            <span class="mx-2" style="min-width: 30px; text-align: center;">
                                                {{getExtraQuantity(extra.id)}}
                                            </span>
                                            <button class="btn quantity-btn" 
                                                    (click)="increaseExtraQuantity(extra)">
                                                <i class="bx bx-plus"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Dynamic Total -->
                            <div class="d-flex justify-content-between align-items-center mb-4">
                                <h5 class="fw-bold mb-0">Total</h5>
                                <div>
                                    <span *ngIf="selectedProduct.offer" class="text-muted text-decoration-line-through me-2">
                                        {{calculateOriginalTotal() | currency}}
                                    </span>
                                    <h4 class="mb-0 d-inline-block" [class.text-danger]="selectedProduct.offer">
                                        {{calculateTotal() | currency}}
                                    </h4>
                                </div>
                            </div>
                        </div>
                        
                        <div class="col-lg-6 quantityImageSection text-center">
                            <img [src]="selectedProduct.avatar" 
                                class="productImage mt-5" 
                                width="300" 
                                height="300" 
                                [alt]="selectedProduct.name">
                            
                            <!-- Quantity Selector -->
                            <div class="d-flex align-items-center mt-5 mb-5 justify-content-center">
                                <button class="btn quantity-btn" (click)="decreaseQuantity()">
                                    <i class="bx bx-minus"></i>
                                </button>
                                
                                <input type="number" 
                                    class="form-control quantity-input text-center mx-2" 
                                    [(ngModel)]="quantity" 
                                    min="1" 
                                    max="99" 
                                    style="width: 60px;">
                                
                                <button class="btn quantity-btn" (click)="increaseQuantity()">
                                    <i class="bx bx-plus"></i>
                                </button>
                            </div>
                            
                            <!-- Add to Cart Button -->
                            <button class="btn btn-primary add-to-cart-btn" (click)="addToCart()">
                                <i class="bx bx-shopping-cart me-2"></i> Add To Cart
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-footer-style-two></app-footer-style-two>